module.exports = __webpack_public_path__ + "img/waukesha_cherry_burrell.41c2f586.png";